import { render, staticRenderFns } from "./DataTableRowExpanded.vue?vue&type=template&id=008e0637"
import script from "./DataTableRowExpanded.vue?vue&type=script&lang=js"
export * from "./DataTableRowExpanded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports